import React, { createContext, useContext, ReactNode } from 'react';
import { RootStore } from '../stores/RootStore';

const StoreContext = createContext<RootStore | null>(null);

const rootStore = new RootStore();

interface StoreProviderProps {
  children: ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  return (
    <StoreContext.Provider value={rootStore}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = (): RootStore => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return store;
};